((Collection, $) => {
  'use strict';
  
  const DESKTOP_BREAKPOINT = 992;
  const SAFARI_MOBILE_BOTTOM_MENU_HEIGHT = 44;
  let totalFilterCount = 0;
  let dom = {}; // vanilla

  const cacheDom = () => {
    dom.collectionSection = document.querySelector('[data-collection-template]').parentElement;
    dom.siteHeader        = document.querySelector('[data-site-header]');
    dom.transformationBar = document.querySelector('[data-transformation-bar] a');
    dom.countdownBar      = document.querySelector('[data-countdown-banner]');
    dom.contentWrapper    = document.querySelector('[data-content-collection]');
    dom.mobileMenuToggle  = document.querySelector('[data-mobile-menu-toggle]');

    dom.filterWrapper     = document.querySelector('[data-collection-filters]');
    dom.filterForm        = document.querySelector('[data-filter-form]');
    dom.collectionGrid    = document.querySelector('[data-collection-grid]');
    dom.noActiveFilters   = document.querySelector('[data-no-filters]');
    dom.noMatchMessage    = document.querySelector('[data-no-match]');
    dom.mobileActiveBar   = document.querySelector('[data-mobile-active-filters-wrapper]');
    dom.mobileStickyBar   = document.querySelector('[data-sticky-filter-mobile]');
    dom.desktopStickyBar  = document.querySelector('[data-sticky-filter-desktop]');
    dom.mobileFilterBtns  = document.querySelector('[data-mobile-filter-buttons]');
    
    dom.filterBars        = document.querySelectorAll('[data-active-filters]');
    dom.filterGroups      = document.querySelectorAll('[data-filters]')
    dom.filterTitles      = document.querySelectorAll('[data-filter-title]');
    dom.filterOptions     = document.querySelectorAll('[data-filter-group]');
    
    dom.totalFilterCounts = document.querySelectorAll('[data-total-filter-count]')
    dom.clearFilters      = document.querySelectorAll('[clear-filters]');
    dom.swatchInputs      = document.querySelectorAll('[data-swatch-input]');
    dom.swatchLabels      = document.querySelectorAll('[data-swatch-label]');
    dom.filterInputs      = document.querySelectorAll('[data-filter-input]');
    dom.filterLabels      = document.querySelectorAll('[data-filter-label]');

  };

  const configMixer = {
    multifilter: {
      enable: true
    },
    controls: {
      toggleLogic: 'and'
    },
    animation: {
      enable: false
    },
    selectors: {
      target: '.collection-product-grid__item-wrapper'
    },
    callbacks: {
      onMixStart: function(state, futureState) {
        // hide the 'no active filters' button
        hideNoFiltersMessage();
        showClearButtons();
        scrollToCollectionTop();
      },
      onMixEnd: function (state) {
        // no items found displays on 'fail state'
        state.hasFailed ? dom.noMatchMessage.style.display = 'flex' : dom.noMatchMessage.style.display = 'none';
        
        // update filter counts
        updateFilterCounts();
        renderActiveFilters();

        // hide clear button if the last operation unchecked all filters
        if(document.querySelectorAll('[data-filter-form] input:checked').length === 0) {
          hideClearButtons();
          // show the 'no active filters' button
          showNoFiltersMessage();
        } 
      }
    }
  };

  const throttle = (func, delay) => {
    let time = Date.now();
    return function() {
      if ((time + delay - Date.now()) < 0) {
        func();
        time = Date.now();
      }
    }
  };

  const toggleClass = (element, className) => {
    if (element.classList.contains(className)) {
      element.classList.remove(className)
    } else {
      element.classList.add(className)
    }
  }

  const setWrapperMargin = () => {
    const transformationBarHeight = dom.transformationBar ? dom.transformationBar.offsetHeight : 0;
    dom.contentWrapper.style.marginTop = `${transformationBarHeight - 1}px`;
  }

  const adjustBottomPositionForSafari = (element, offsetBottom) => {
    const {bottom} = element.getBoundingClientRect();
    const offset = offsetBottom ? offsetBottom : 0;

    element.style.bottom = (Math.floor(bottom) > window.innerHeight) 
      ? offset + SAFARI_MOBILE_BOTTOM_MENU_HEIGHT + 'px'
      : offset + 'px';

    return;
  };

  const adjustMobileSafariElements = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      const mobileFilterOverlay = dom.filterWrapper;
      const mobileFilterButtons = dom.mobileFilterBtns;
      adjustBottomPositionForSafari(mobileFilterOverlay);
      adjustBottomPositionForSafari(mobileFilterButtons, 44);
    }
    return;
  }

  const scrollToCollectionTop = () => {
    if(window.scrollY > dom.collectionSection.offsetTop) {
      window.scrollTo(0, dom.collectionSection.offsetTop - 80);
    }
  }

  const hideNoFiltersMessage = () => {
    if(window.innerWidth > DESKTOP_BREAKPOINT) {
      dom.noActiveFilters.style.display = 'none';
    }
  }
  const showNoFiltersMessage = () => {
    if(window.innerWidth > DESKTOP_BREAKPOINT) {
      dom.noActiveFilters.style.display = 'block';
    }
  }

  const openMobileFilters = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      // setup window object to delegate the mobile menu toggle click event
      window.collectionFiltersActive = true;
      dom.mobileMenuToggle.classList.add('is-active');
      setupMobileMenuListener();

      // open filters
      toggleClass(dom.filterWrapper, 'active');
      
      // prevent scrolling behind the filter menu
      Scroll.lock();
    }
  }

  const closeMobileFilters = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      window.collectionFiltersActive = false;
      toggleClass(dom.filterWrapper, 'active');
    }

    // reset mobile toggle functionality + look
    dom.mobileMenuToggle.classList.remove('is-active');
    dom.mobileMenuToggle.removeEventListener('click', handleMobileMenuToggle);

    // re-enable scrolling
    Scroll.unlock();
  }

  const showClearButtons = () => {
    const buttons = Array.from(dom.clearFilters);
    buttons.forEach(btn => {
      btn.classList.add('is-visible');
    })
  }

  const hideClearButtons = () => {
    const buttons = Array.from(dom.clearFilters);
    buttons.forEach(btn => {
      btn.classList.remove('is-visible');
    })
  }

  const clearFilters = () => {
    const swatchLabels = Array.from(dom.swatchLabels);
    const filterLabels = Array.from(dom.filterLabels);
    const allFilterLabels = filterLabels.concat(swatchLabels);

    hideClearButtons();
    allFilterLabels.forEach(label => label.classList.remove('selected'));
    dom.filterForm.reset();
  }

  const updateFilterCounts = () => {
    const filterGroups = Array.from(dom.filterGroups);
    let totalCount = 0;

    filterGroups.forEach(group => {
      let localCount = 0;

      const checkedInputs = Array.from(group.querySelectorAll('input:checked'));
      localCount += checkedInputs.length;
      totalCount += checkedInputs.length;

      const countSpan = group.querySelector('[data-filter-title] span');
      countSpan.textContent = localCount > 0 ? `(${localCount})` : ''
      
    });

    // update totalCount
    const totalCountSpans = Array.from(dom.totalFilterCounts);
    totalCountSpans.forEach(span => span.textContent = totalCount > 0 ? `(${totalCount})` : '');
    totalFilterCount = totalCount; // used only to adjust margin of mobile collection grid
    
  }

  const renderActiveFilters = () => {
    const activeInputs = Array.from(document.querySelectorAll('[data-filter-form] input:checked'));
    const activeLabels = activeInputs.map(input => input.getAttribute('data-label'))
    const filterBars = Array.from(dom.filterBars);

    if (activeInputs.length === 0) {
      filterBars.forEach(bar => Array.from(bar.querySelectorAll('[data-filter-value]')).forEach(btn => btn.remove())); // clear out filters
      dom.mobileActiveBar.style.display = 'none'; // hide mobile filter bar
    } else {
      dom.mobileActiveBar.style.display = 'flex'; // show mobile filter bar
    }
    // get current filters
    const activeButtons = Array.from(document.querySelectorAll('[data-active-filters] button[data-filter-value]'));
    const currentFilters = new Set(activeButtons.map(button => button.getAttribute('data-filter-value')));

    // get new filters + add them
    const newFilters = activeLabels.filter(label => !currentFilters.has(label));
    newFilters.forEach(label => addFilterButton(label));

    // get stale filters + remove them
    const staleFilters = [...currentFilters].filter(filter => !activeLabels.includes(filter));
    staleFilters.forEach(filter => removeFilterButton(filter));
  }

  const addFilterButton = (value) => {
    const filterBars = Array.from(dom.filterBars);

    filterBars.forEach(bar =>  {
      const button = document.createElement('button');
      const span = document.createElement('span');
      span.textContent = value.replace(/-/g, ' ').replace(/and/g, '&');
      button.appendChild(span);
      button.setAttribute('data-filter-value', value);
      button.addEventListener('click', handleActiveFilterButtonClick);
      bar.appendChild(button);
    });
  }

  const removeFilterButton = value => {
    const filterBars = Array.from(dom.filterBars);
    filterBars.forEach(bar => {
      const buttons = Array.from(bar.querySelectorAll('button[data-filter-value]'));
      buttons.forEach(button => {
        if(button.getAttribute('data-filter-value') === value) {
          button.remove();
        }
      })
    });
  }

  const handleActiveFilterButtonClick = event => {
    const target = (event.target.matches('span')) ? event.target.parentElement : event.target;
    const filterName = target.getAttribute('data-filter-value');
    removeFilter(filterName); // remove filter
    target.remove(); // remove button
  }

  const removeFilter = filterName => {
    const activeInputs = Array.from(document.querySelectorAll('[data-filter-form] input:checked'));
    const filterInput = activeInputs.find(input => input.getAttribute('data-label') === filterName);
    filterInput.checked = false; // remove filter
    filterInput.dispatchEvent(new Event('change', { 'bubbles': true })); // trigger change event (for mixitup)
    updateFilterCounts();
  }

  const handleMobileMenuToggle = () => {
    closeMobileFilters();
  }

  const setupMobileMenuListener = () => {
    if(dom.mobileMenuToggle) {
      dom.mobileMenuToggle.addEventListener('click', handleMobileMenuToggle);
    }
  }

  const setMobileFilterMenuPaddingTop = () => {
    
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      let bottomOfHeader = 0;
  
      const headerHeight = dom.siteHeader ? dom.siteHeader.offsetHeight : 0;
      bottomOfHeader += headerHeight;
  
      if(dom.transformationBar) {
        const fullTransformationBar = dom.transformationBar.parentElement;
        bottomOfHeader += fullTransformationBar ? fullTransformationBar.offsetHeight : 0;
      }

      dom.filterWrapper.style.paddingTop = `${bottomOfHeader}px`;
    } else {
      dom.filterWrapper.style.paddingTop = 0;
    }
  }

  const setStickyPositioning = () => {
    let bottomOfHeader = 0;

    const headerHeight = dom.siteHeader ? dom.siteHeader.offsetHeight : 0;
    bottomOfHeader += headerHeight;

    if(dom.transformationBar) {
      const fullTransformationBar = dom.transformationBar.parentElement;
      bottomOfHeader += fullTransformationBar ? fullTransformationBar.offsetHeight : 0;
    }

    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      dom.mobileStickyBar.style.top = `${bottomOfHeader - 2}px`;
    } else {
      bottomOfHeader += dom.countdownBar ? dom.countdownBar.offsetHeight : 0;
      dom.desktopStickyBar.style.top = `${bottomOfHeader}px`;
    }
  }

  const initFilters = () => {
    // instantiate mixitup
    mixitup(dom.collectionGrid, configMixer);
  }

  const setHeaderDependentValues = () => {
    setStickyPositioning();
    setMobileFilterMenuPaddingTop();
  }

  const handleResize = () => {
    setWrapperMargin();
    setHeaderDependentValues();
  }

  const handleScroll = () => {
    adjustMobileSafariElements();
  }

  const bindUIActions = () => {

    // only trigger this code on collections with filtering
    if(dom.filterWrapper) {

      // set positioning on load (update on resize)
      window.addEventListener('load', setHeaderDependentValues);

      // page + layout adjustments
      window.addEventListener('resize', throttle(handleResize, 150));
      window.addEventListener('scroll', throttle(handleScroll, 150));
      
      // click listener
      document.addEventListener('click', event => {
        const el = event.target;

        // OPEN MOBILE FILTERS
        if(el.matches('[data-open-mobile-filters]') 
          || (el.parentElement && el.parentElement.matches('[data-open-mobile-filters]'))) {
          openMobileFilters();
        }

        // OPEN FILTER DROPDOWNS
        if(el.matches('.filter-group__title, .filter-group__title span')) {
          const optionsList = el.nextElementSibling;
          toggleClass(el, 'active');
          toggleClass(optionsList, 'active');
          return;
        }

        // CLEAR FILTERS (+ account for buttons with spans)
        if(el.matches('[clear-filters]') 
          || (el.parentElement && el.parentElement.matches('[clear-filters]'))) {
          clearFilters();
        }

        // CLOSE MOBILE FILTERS
        if(el.matches('[data-apply-mobile-filters], [data-mobile-clear]')) {
          closeMobileFilters();
        }
      });

      // ADD + REMOVE ACTIVE CLASSES ON INPUTS
      const filterInputs = Array.from(dom.filterInputs);
      const swatchInputs = Array.from(dom.swatchInputs);
      const allFilterInputs = filterInputs.concat(swatchInputs);

      allFilterInputs.forEach(input => {
        input.addEventListener('change', (event) => {
          const label = event.target.parentElement;
          toggleClass(label, 'selected');
        });
      });

    }
  }

  Collection.init = () => {
    cacheDom();
    bindUIActions();
    setWrapperMargin();
    if(dom.filterWrapper) {
      initFilters();
    }
  };

})(window.Collection = window.Collection || {}, jQuery);
